/*==========================================================
HOMEPAGE RESPONSIVE SCRIPTS
==========================================================*/

$(function() {
    if ($('#uber').hasClass('interior')) {
        // Add class to uber if calendar template
        if ($('#CalendarTemplate').length > 0){
          $('#uber').addClass('calendarView');
        }
    }

  //move contact and subscribe under content
  function moveElements() {
    if (Modernizr.mq('only screen and (max-width: 991px)')) {
      // Mobile
      if ($('#subNavWrapper #contactMainContainer').is('*')) { $('#contactMainContainer').detach().appendTo('#contentInt'); } // Contact
      if ($('#subNavWrapper #pageSubscription').is('*')) { $('#pageSubscription').detach().appendTo('#contentInt'); } // Page Subscription

    } else {
      // Desktop
      if ($('#contentInt > #contactMainContainer').is('*')) { $('#contactMainContainer').detach().appendTo('#subNavWrapper'); } // Contact
      if ($('#contentInt > #pageSubscription').is('*')) { $('#pageSubscription').detach().appendTo('#subNavWrapper'); } // Page Subscription
    }
  }

  moveElements();

  $(window).on('resize',function(){
    moveElements();
  });
  $('.toggle, .extendedToggle').attr('tabindex','0' ).attr('aria-expanded','false');
  $('li.open > .toggle').attr('aria-expanded','true');
  $('.extendedToggle').attr('tabindex','0' );
  $('.subNavTrigger').attr('aria-expanded', 'false');
});
